var saveImage = function saveImage() {
  throw new Error('Uni API: saveImage不支持');
};

export default saveImage;